// removed by extract-text-webpack-plugin
module.exports = {"color-input":"Pp2Zf-4Q_gYayxgBDAjqv","label":"YZHf98eXbeHiuyEvfMvMs","color-box":"_1UB3hHerQ-_V4-_-_kML_8","color":"_5UAo55Oo7dA-zMALbrc8R","error":"_2iOm8YqpI1IK2EiuRGCEAa","input":"_3Za4eT56zZ6SXRnoDYPTED","disabled":"_38cjL8TB8Fbnq9plUplpL7","hint":"JicjPIvCM_93_izHC2pkP","empty":"_1qhrulEei5FcmETqZIK619","spin":"tZx_TOK2G7MuNErMtNJlG"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/Input/ColorInput/styles.scss
// module id = 1155
// module chunks = 18